"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueService = exports.BoundQueue = exports.DEFAULT_OPTIONS = void 0;
/** The default options for queue services */
exports.DEFAULT_OPTIONS = {};
/**
 * A version of {@link QueueService}, bound with the specified {@link Queue}
 */
class BoundQueue {
    constructor(service, queue) {
        this.service = service;
        this.queue = queue;
        this.sendMessage = service.sendMessage.bind(service, queue);
        this.receiveMessage = service.receiveMessage.bind(service, queue);
        this.deleteMessage = service.deleteMessage.bind(service, queue);
    }
}
exports.BoundQueue = BoundQueue;
/**
 * An abstract {@link Service} responsible for communicating with a third-party
 * queue service.
 *
 * @remarks
 * The Queue service is responsible for interfacing with services like AWS Simple Queue
 * Service (SQS). The typical flow of usage is as follows:
 *
 * - Features register a queue with the queue service through a queue resource of some sort.
 *
 * - New clients create an instance of a {@link BoundQueue} (likely through a services manager)
 *   by calling `queue()` with the identifier of the queue resource.
 *
 * - They then call {@link QueueService.sendMessage | sendMessage()} whenever they would like to
 *   send a message to the queue.
 *
 * APIs for receiving messages and deleting messages are also exposed through the use of
 * receiveMessage and deleteMessage. Typically, a watcher script will continually
 * call receiveMessage until a new message is returned. It will then process it, and call
 * deleteMessage once it is complete, or do nothing if it fails (the message should expire
 * and be added back to the queue).
 */
class QueueService {
    constructor(options) {
        this.options = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), options);
    }
}
exports.QueueService = QueueService;
//# sourceMappingURL=QueueService.js.map